/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getWarrantyIconsAsync } from './DataActionExtension.g';
import { IWarrantyIcon } from './DataServiceEntities.g';

/**
 * GetWarrantyIcon Input Action
 */
export class GetProductWarrantyIconInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `mmx-productwarranty-icons`;
    public getCacheObjectType = () => 'IWarrantyIcon';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetProductWarrantyIconInput();
};

async function action(input: GetProductWarrantyIconInput, ctx: Msdyn365.IActionContext): Promise<IWarrantyIcon[]> {
    return getWarrantyIconsAsync({ callerContext: ctx });
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IWarrantyIcon[]>>action,
    id: 'GetWarrantyIcon',
    input: createInput
});
